import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'servicedesk.knowledge-hub.flags.remove-label-from-article-failure.title',
		defaultMessage: 'We couldn’t save the changes you made',
		description: 'Flag title when remove label from an article operation fails',
	},
	description: {
		id: 'servicedesk.knowledge-hub.flags.remove-label-from-article-failure.description',
		defaultMessage: 'Refresh the page and try again.',
		description: 'Flag description when remove label from an article operation fails',
	},
});
